import { render } from "./GridTableCategory.vue?vue&type=template&id=9f3c546c"
import script from "./GridTableCategory.vue?vue&type=script&lang=js"
export * from "./GridTableCategory.vue?vue&type=script&lang=js"

import "./GridTableCategory.vue?vue&type=style&index=0&id=9f3c546c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__